import { Api } from "../config/request";

export default {
  fetchBannerList(data) {
    return Api.post("/banner/list", {
      ...data,
    });
  },

  fetchBannerDetails(bannerId) {
    return Api.get(`/banner/detail?banner_id=${bannerId}`);
  },

  createBanner(bannerData) {
    return Api.post("/banner/create", bannerData);
  },

  editBanner(bannerData) {
    return Api.post("/banner/edit", bannerData);
  },

  fetchBannerTargetAudience(bannerId) {
    return Api.get(`/banner/entity_mapping?banner_id=${bannerId}`);
  },

  createBannerTargetAudience(data) {
    return Api.post("/banner/create_entity_mapping", data);
  },

  postImage(imageData) {
    return Api.post("/banner/upload_image", imageData);
  },

  getBulkUploadUrl(data) {
    return Api.post("/banner/bulk_assign", data);
  },
};
